const config = {
  version: '2.6.6',
  type: 'js'
};

export default config;


// WEBPACK FOOTER //
// ./src/config.ts